export default __webpack_public_path__ + "3cf44c5e956c07a1ebdb3eafdf6cd241.png";